(function () {
  function init() {
    var roots = document.querySelectorAll('.newsletter-popup');

    if (!roots.length) {
      console.warn('[newsletter-popup] no .newsletter-popup element found on page');
      return;
    }

    roots.forEach(function (root) {
      var cookieName = root.dataset.cookieName || 'newsletter_popup_dismissed';
      var delay = (parseFloat(root.dataset.delay) || 0) * 1000;
      var discountCode = root.dataset.discountCode || '';

      if (getCookie(cookieName)) {
        return; // already dismissed/subscribed on this browser
      }

      var signupStep = root.querySelector('[data-step="signup"]');
      var successStep = root.querySelector('[data-step="success"]');
      var form = root.querySelector('form');
      var errorEl = root.querySelector('[data-popup-error]');
      var codeEl = root.querySelector('[data-popup-code]');
      var copyBtn = root.querySelector('[data-popup-copy]');
      var copiedEl = root.querySelector('[data-popup-copied]');

      var timer = setTimeout(function () {
        showPopup(root);
      }, delay);

      root.querySelectorAll('[data-popup-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          hidePopup(root);
          setCookie(cookieName, '1', 365);
        });
      });

      if (!form) {
        console.warn('[newsletter-popup] no <form> found inside popup');
      } else {
        // Capture phase + stopImmediatePropagation so another script on the
        // page can't swallow this submit event before we get to prevent
        // the real navigation (which is what causes the "jumps to the
        // bottom of the page" symptom on /contact#...).
        form.addEventListener(
          'submit',
          function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            try {
              var emailInput = form.querySelector('input[type="email"]');
              var email = emailInput ? emailInput.value.trim() : '';

              if (!isValidEmail(email)) {
                if (errorEl) errorEl.hidden = false;
                return;
              }
              if (errorEl) errorEl.hidden = true;

              var submitBtn = form.querySelector('button[type="submit"]');
              if (submitBtn) submitBtn.disabled = true;

              fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin'
              })
                .catch(function (err) {
                  // Shopify's /contact endpoint doesn't return JSON; network
                  // errors aside, we still reveal the code below.
                  console.warn('[newsletter-popup] submit fetch failed', err);
                })
                .finally(function () {
                  if (submitBtn) submitBtn.disabled = false;
                  revealSuccess();
                  setCookie(cookieName, '1', 365);
                });
            } catch (err) {
              console.error('[newsletter-popup] submit handler error', err);
            }
          },
          true
        );
      }

      if (copyBtn && codeEl) {
        copyBtn.addEventListener('click', function () {
          var text = discountCode || codeEl.textContent.trim();
          copyToClipboard(text).then(function () {
            if (copiedEl) {
              copiedEl.hidden = false;
              setTimeout(function () {
                copiedEl.hidden = true;
              }, 2500);
            }
          });
        });
      }

      function revealSuccess() {
        if (signupStep) signupStep.hidden = true;
        if (successStep) successStep.hidden = false;
      }
    });

    function showPopup(root) {
      root.classList.add('is-visible');
      root.setAttribute('aria-hidden', 'false');
    }

    function hidePopup(root) {
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function setCookie(name, value, days) {
      var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
    }

    function getCookie(name) {
      var match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return match ? match.pop() : '';
    }

    function copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
      } finally {
        document.body.removeChild(textarea);
      }
      return Promise.resolve();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();